<template>
  <div>
    <h3>基本信息</h3>
    <table class="table" cellspacing="0" border="1">
      <tr>
        <td class="title">流水号</td>
        <td>{{ formData.sheetId || '/' }}</td>
        <td class="title">申请日期</td>
        <td>{{ formData.applyDate }}</td>
        <td class="title">流程状态</td>
        <td style="width:100px">{{ formData.state | stateFilter }}</td>
      </tr>
      <tr>
        <td class="title">申请人</td>
        <td>{{ formData.applyPerson }}</td>
        <td class="title">所属部门</td>
        <td colspan="3">{{ formData.department }}</td>
      </tr>
    </table>
    <h3 style="margin-top:10px">调阅信息</h3>
    <table class="table" cellspacing="0" border="1" v-for="(project,index) in projectInfo" :key="index" style="margin-top:10px">
      <tr>
        <td class="title"><span style="color:red">*</span>项目名称</td>
        <td colspan="2">
          <Select
            v-model="project.projectName" 
            style="width:100%" 
            filterable 
            placeholder="请输入项目名称进行搜索" 
            remote
            :remote-method="getProject"
            :loading="loading"
            @on-change="selectProject($event,index)"
            :disabled="disabled"
          >
            <Option v-for="item in projectList" :value="item.projectName" :key="item.id">{{ item.projectName }}</Option>
          </Select>
        </td>
        <td class="title">项目编号</td>
        <td colspan="2">{{ project.projectFull }}</td>
      </tr>
      <tr v-for="(item,i) in project.checkList" :key="i">
        <td class="title" :rowspan="project.checkList.length" v-if="i===0">
          <span style="color:red">*</span>
          资料清单
        </td>
        <td class="title"><span style="color:red">*</span>文件类型</td>
        <td>
          <Select style="width:200px" v-model="project.checkList[i].filetype" :disabled="disabled">
            <Option v-for="type in fileType" :value="type" :key="type">{{ type }}</Option>
          </Select>
        </td>
        <td class="title"><span style="color:red">*</span>数量</td>
        <td><Input v-model="project.checkList[i].amount" :disabled="disabled"/></td>
        <td style="color:#1890ff;text-align:center;padding:0 6px" v-if="i===0&&!disabled" @click="project.checkList.push({amount:'',filetype:''})">
          <Icon type="ios-plus-outline" size="16"></Icon> 添加
        </td>
        <td style="color:#ff0000;text-align:center;padding:0 6px" v-if="i!==0&&!disabled" @click="delList(index, i)">
          <Icon type="ios-minus-outline" size="16"></Icon> 删除
        </td>
      </tr>
      <tr>
        <td class="title">备注</td>
        <td :colspan="index===0?'5':'4'">
          <Input v-model="project.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" :disabled="disabled"></Input>
        </td>
        <td style="color:#ff0000;text-align:center;padding:0 6px" @click="delprojectList(index)" v-if="index!==0&&!disabled">
          删除
        </td>
      </tr>
    </table>
    <p style="text-align:center;margin-top:10px" v-if="!disabled">
      <Button type="primary" @click="addProject">新增项目</Button>
    </p>
    <h3 style="margin-top:10px">归还信息</h3>
    <table class="table" cellspacing="0" border="1">
      <tr>
        <td class="title"><span style="color:red">*</span>是否归还</td>
        <td>
          <Select v-model="formData.isReturn" @on-change="(e)=>{formData.expectReturnDate=''}" :disabled="disabled">
            <Option v-for="item in ['是', '否']" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </td>
        <template v-if="isReturn === false">
          <td class="title"><span style="color:red">*</span>不归还原因</td>
          <td>
            <Input v-model="formData.notReturnReason" :disabled="disabled"></Input>
          </td>
        </template>
        <template v-else>
          <td class="title"><span style="color:red">*</span>预计归还时间</td>
          <td>
            <DatePicker type="datetime" style="width:200px" v-model="formData.expectReturnDate" :disabled="disabled"></DatePicker>
          </td>
        </template>
      </tr>
      <tr>
        <td class="title"><span style="color:red">*</span>调阅原因</td>
        <td colspan="3">
          <Input v-model="formData.shiftingReason" type="textarea" :autosize="{minRows: 2,maxRows: 5}" :disabled="disabled"></Input>
        </td>
      </tr>
      <tr>
        <td class="title">附件上传</td>
        <td colspan="3">
          <div style="display: flex;align-items: center">
            <Upload
              :data="uploadFileInit.extradata" 
              :action="uploadFileInit.action" 
              :before-upload="handleBeforeUpload"
              :show-upload-list="false">
              <Button type="ghost" icon="ios-cloud-upload-outline">选择文件</Button>
            </Upload>
            <div style="flex:1;margin-left:14px">
              <p v-for="file in fileList" :key="file.id" class="fileList" @click="previewFile(file.id)">
                {{ file.name }}
                <Icon type="ios-close-empty" size="18" @click="deleteFile(file)"></Icon>
              </p>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { formatDate, guid } from '@/lib/tool'
import { fileUtil } from '@/lib/abpfile'

export default {
  props: {
    formInfo: Object
  },
  data() {
    return {
      formData: {
        // id: 0,
        // packageNumber: "string",
        applyDate: formatDate(),
        flowId: guid(),
        applyPerson: this.$store.state.session.user.name,
        department: this.$store.state.session.listOrg[0].displayName,
        shiftingJson: "",
        isReturn: "",
        expectReturnDate: "",
        returnDate: "",
        shiftingReason: "",
        notReturnReason: ''
      },
      fileType: ['复印件', '原件', '其他'],
      projectList: [],
      loading: false,
      projectInfo: [{
        projectName: '',
        projectFull: '',
        remark: '',
        checkList: [{
          filetype: '',
          amount: ''
        }]
      }],
			bucket: 'clneiwang',
      dir: 'document/',
      uploadFileInit: {
        action: '',
        extradata: {}
      },
      fileList: []
    }
  },
  computed: {
    isReturn () {
      return this.formData.isReturn === '是' ? true :this.formData.isReturn === '否' ? false : undefined
    },
    form () {
      return Object.assign(this.formData, {
        expectReturnDate: formatDate(this.formData.expectReturnDate),
        shiftingJson: JSON.stringify(this.projectInfo)
      })
    },
    projectValid () {
      let isFilled = true
      for (let i = 0; i < this.projectInfo.length; i++) {
        if (!this.projectInfo[i].projectName || !this.projectInfo[i].projectFull) {
          isFilled = false
          break
        }
        this.projectInfo[i].checkList.forEach(item => {
          if (!item.filetype || !item.amount) isFilled = false
        })
      }
      return isFilled
    },
    disabled () {
      return Boolean(this.formInfo && this.formInfo.sheetId)
    }
  },
  filters: {
    stateFilter (val) {
      if (!val) return '/'
      switch (val) {
        case 3: return '成功'
          break
        case 5: return '驳回'
          break
        case 2: return '审批中'
          break
      }
    }
  },
  watch: {
    formInfo (val) {
      this.formData = val
      this.projectInfo = JSON.parse(val.shiftingJson)
      this.getHistory(val.flowId)
    }
  },
  methods: {
    async getProject (e) {
      if (!e) {
        this.projectList = []
        return
      }
      this.loading = true
      let rep = await ajax.get(requestUrls.ClProjectDb.getPaged, {
        params: {
          filter: `(projectState.Contains("已开评标完") or projectState.Contains("项目失败") or projectState.Contains("项目结项")) and projectName.Contains("${e}")`,
          maxResultCount: 1000,
          skipCount: 0
        }
      })
      if (rep.data.success) {
        this.loading = false
        this.projectList = rep.data.result.items
      }
    },
    addProject () {
      this.projectInfo.push({
        projectName: '',
        projectFull: '',
        remark: '',
        checkList: [{
          filetype: '',
          amount: ''
        }]
      })
    },
    delList (index, i) {
      this.projectInfo[index].checkList.splice(i, 1)
    },
    delprojectList (index) {
      this.projectInfo.splice(index, 1)
    },
    validFrom () {
      let a = !this.formData.isReturn || (this.isReturn && !this.formData.expectReturnDate) || (!this.isReturn && !this.formData.notReturnReason) ||!this.formData.shiftingReason
      if (a || !this.projectValid) {
        this.$Message.error('请完善表格信息！')
      } else {
        // 流程标题
        let title = `【档案调阅】${this.projectInfo[0].projectFull}`
        if ( this.projectInfo.length > 1) title = title + '与其他'
        this.$emit('startFlow', this.form, title)
      }
    },
    selectProject (e, index) {
      let project = this.projectList.filter(item => item.projectName === e)[0]
      this.projectInfo[index].projectFull = project.projectFull
    },
    // 选择文件
    handleBeforeUpload(file) {
      console.log(file)
			// 初始化文件上传
      fileUtil.downloadInit(this.$store.state.session.user.id, 1, this.bucket,this.dir).then(val => {
        this.uploadFileInit = val
      })
      this.file = file
			this.$set(this.file, 'displayName', file.name)
			setTimeout(() => {
				this.upLoad()
			},500)
      return false
    },
    // 上传文件
    async upLoad() {
			let suffix = fileUtil.get_suffix(this.file.name)
			this.uploadFileInit.extradata.key = this.uploadFileInit.extradata.key + fileUtil.random_string(10) + suffix
			this.uploadFileInit.extradata['x:displayname'] = this.file.name
			this.uploadFileInit.extradata['x:objectid'] = this.formData.flowId
			this.uploadFileInit.extradata['x:objectidtype'] = 'document'
			this.$Spin.show()
			try {
				let uploadData = new FormData()
				for (let key in this.uploadFileInit.extradata) {
					uploadData.append(key, this.uploadFileInit.extradata[key])
				}
				uploadData.append('file', this.file)
				let rep = await ajax.post(this.uploadFileInit.action, uploadData)
				this.$Spin.hide()
				if (rep.data.success) {
					this.$Message.success(`${this.file.displayName}上传成功`)
          this.file = ''
				} else {
					this.$Message.error(`${this.file.displayName}上传失败`)
				}
			} catch (err) {
				console.error(err)
				this.$Spin.hide()
				this.$Message.error(`${this.file.displayName}上传失败`)
			}
			this.getHistory(this.formData.flowId)
			return
    },
    // 获取历史文件
		async getHistory(id) {
			this.fileList = []
      // 获取历史上传文件
      let rep = await ajax.get(requestUrls.AbpAliOss.GetListByObjectId,{
        params: {
          objectId: id,
          objectIdType: 'document',
          fileType: '1'
        }
			})
			this.fileList = rep.data.result.items.map(item => {
        return {
          id: item.id,
          name: item.displayName,
          objectId: item.objectId
        }
      })
    },
    // 删除文件
    deleteFile(file) {
      this.$Modal.confirm({
        title: '文件删除',
        okText: '删除',
        cancelText: '取消',
        content: `确定要删除${file.name}吗?`,
        onOk: () => {
          ajax.delete(requestUrls.AbpAliOss.Delete, {
            params: {
              id: file.id
            }
          }).then(() => {
            this.getHistory(this.formData.flowId)
            this.$Message.success('删除成功')
          })
        },
        onCancel: () => {}
      })
    },
    // 文件预览
    previewFile (fileId) {
      fileUtil.downLoad(fileId).then(res => {
        this.$showImage(res)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  width: 100%;
  border-collapse: collapse;
  border-color: #ddd;
  tr, td {
    border: 1px solid #ddd;
  }
  td {
    padding: 6px 10px;
    white-space: nowrap;
  }
  .title {
    width: 78px;
    background-color: #f5f5f5;
    height: 32px;
    line-height: 32px;
    border-radius: 0;
    text-align: center;
    padding: 0 10px;
  }
  .fileList {
    padding: 0 6px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover {
      background-color: #f5f5f5;
      color: #2d8cf0;
    }
  }
}
</style>